import React from 'react';
import { string } from 'prop-types';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { vatFromTransaction, noteText } from '../../util/vat';

import css from './BookingBreakdown.css';

// The legally required wording for every 0 % supply on the viewer's side
// (Notion §6): the work for both parties, the service fee for the customer.
// Nothing for legacy transactions. The same note is printed once.
const VatNote = ({ transaction, userRole, intl }) => {
  const v = vatFromTransaction(transaction);
  if (v.legacy) return null;
  const supplies = userRole === 'customer' ? [v.customer, v.serviceFee] : [v.provider];
  const texts = supplies
    .filter(s => s && !(s.rate > 0) && s.noteKey !== 'STANDARD')
    .map(s => noteText(s.noteKey, intl.locale, { exemptId: v.seller && v.seller.exemptId }))
    .filter(Boolean)
    .filter((text, i, all) => all.indexOf(text) === i);
  return texts.length ? (
    <>
      {texts.map(text => (
        <p key={text} className={css.feeInfo}>
          {text}
        </p>
      ))}
    </>
  ) : null;
};

VatNote.propTypes = {
  transaction: propTypes.transaction.isRequired,
  userRole: string.isRequired,
  intl: intlShape.isRequired,
};
export default injectIntl(VatNote);
